import(/* webpackMode: "eager" */ "/vercel/path0/src/app/projects/barista/page.tsx");
